//react
import React, { Component } from 'react';
import { Link } from 'react-router-dom';

//components
import Footer from '../../components/footer/footer';
import Header from '../../components/header/header';
import NavContent from '../../components/navContent/navContent';
import Translation from '../../components/translation/translation';

//data
import dataTranslations from './translations.json';

class PageNotFound extends Component {
	componentDidMount() {
		document.body.scrollTop = document.documentElement.scrollTop = 0;
	}

	render() {
		const culture = this.props.match.params.culture;
		const section = this.props.match.params.section;

		let contentPage = false;

		if (culture) {
			contentPage = true;
		}

		if (section) {
			return (
				<div className="wrapper">

					<Header contentPage={contentPage} pageNotFound={true} culture={culture} />

					<section className="content-page">
						<div className="container">
							<div className="container__row">
								<div className="container__column container__column--third container__column--top">
									<NavContent culture={culture} section={section} />
								</div>
								<div className="container__column container__column--top">
									<div className="content-page__content">
										<h1><Translation culture={culture} data={dataTranslations} name="title" /></h1>
										<p><Translation culture={culture} data={dataTranslations} name="body" /></p>
										<p><Link to="/"><Translation culture={culture} data={dataTranslations} name="link" /></Link></p>
									</div>
								</div>
							</div>
						</div>
					</section>

					<Footer contentPage={contentPage} culture={culture} />

				</div>
			);
		}

		return (
			<div className="wrapper">

				<Header contentPage={contentPage} pageNotFound={true} culture={culture} />

				<section className="page-not-found">
					<div className="container">
						<h1><Translation culture={culture} data={dataTranslations} name="title" /></h1>
						<p><Translation culture={culture} data={dataTranslations} name="body" /></p>
						<p><Link to="/"><Translation culture={culture} data={dataTranslations} name="link" /></Link></p>
					</div>
				</section>

				<Footer contentPage={contentPage} culture={culture} />

			</div>
		);
	}
}

export default PageNotFound;



// WEBPACK FOOTER //
// ./src/pages/pageNotFound/pageNotFound.js